import XeroDeepLink from '../../../../components/XeroDeepLink';
import { Worksheet } from '../../../../types/worksheet';
import RefreshXeroAccount from './integration-actions/RefreshXeroAccount';
import PrevNext from './PrevNext';
import ReviewButton from './ReviewButton';
import SecondaryActions from './SecondaryActions';

type TopActionsProps = {
    worksheet: Worksheet;
    hideTransactionsLink?: boolean;
    separatorHeight?: number;
    onXeroAuthError?: () => void;
    dataIntercomTarget?: string;
};

function TopActions({
    worksheet,
    hideTransactionsLink = false,
    separatorHeight = 20,
    onXeroAuthError,
    dataIntercomTarget,
}: TopActionsProps): JSX.Element {
    const integrationActions = worksheet.account !== null && worksheet.account?.provider === 'XERO';

    return (
        <div className="flex gap-4 items-center shrink-0">
            {integrationActions && <RefreshXeroAccount onXeroAuthError={onXeroAuthError} />}
            {integrationActions && !hideTransactionsLink && (
                <>
                    <XeroDeepLink label="View transactions" reportId={1009} />
                    <div className="w-[1px] bg-gray-200" style={{ height: separatorHeight }}></div>
                </>
            )}

            <PrevNext worksheetId={worksheet.id} />
            <div className="w-[1px] bg-gray-200" style={{ height: separatorHeight }}></div>
            <div className="flex items-center">
                <ReviewButton worksheet={worksheet} />
                <div {...(dataIntercomTarget ? { 'data-intercom-target': dataIntercomTarget } : {})}>
                    <SecondaryActions worksheet={worksheet} />
                </div>
            </div>
        </div>
    );
}

export default TopActions;
